exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-msg-type {\n  text-transform: capitalize; }\n\nimg.bannerImg {\n  max-width: 300px !important;\n  max-height: 80px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/app/style/banners/AddBanners.scss
// module id = 390
// module chunks = 0